import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import Order from 'src/smoothr-web-app-core/models/Order';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import {OrderUtils} from 'src/smoothr-web-app-core/utils/order-utils';
import {numberToCurrency} from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-payment-info',
	templateUrl: './payment-info.component.html',
	styleUrls: ['./payment-info.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentInfoComponent {
	public order: Order;
	public venue: Venue;
	numberToCurrency = numberToCurrency;
	OrderUtils = OrderUtils;

	constructor(private modalCtrl: ModalController) {}

	static async show(modalCtrl: ModalController, order: Order, venue: Venue) {
		const modal = await modalCtrl.create({
			cssClass: 'payment-info-modal ',
			component: PaymentInfoComponent,
			componentProps: {
				order,
				venue
			},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
